/**
 * Utility functions for date formatting across the portal.
 */

/**
 * Formats a Date object into Indian Standard date string (e.g., "10 Aug 2026").
 */
export const formatDateIN = (date?: Date | string | number | null): string => {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

/**
 * Formats a Date object into Long US date string (e.g., "Monday, August 10, 2026").
 */
export const formatDateLong = (date?: Date | string | number | null): string => {
  if (!date) return "";
  const d = new Date(date);
  return d.toLocaleDateString("en-US", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
};

/**
 * Parses a "YYYY-MM-DD" string into a Date object without timezone shift issues.
 */
export const parseYMD = (dateStr: string): Date => {
  const [y, m, d] = dateStr.split("-").map(Number);
  return new Date(y, m - 1, d);
};

/**
 * Formats a Date object into a "YYYY-MM-DD" string.
 */
export const formatYMD = (date: Date): string => {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

